import {Component} from '@angular/core';
import {ProcessReportBase} from "../process-report-base";

@Component({
    selector: 'app-process-info',
    templateUrl: './process-info-report.component.html',
    styleUrls: ['./process-info-report.component.scss']
})
export class ProcessInfoReportComponent extends ProcessReportBase {
}
